var WarTemplate = function WarTemplate(card, sobj) {
  var winner = sobj.winner;
  var roll = sobj.die;
  var modifications = sobj.modifications;
  var modroll = roll - modifications;
  var success = sobj.success;
  var player = sobj.player;
  var winner_css = 'winner-us';
  if (player == 'ussr' && success == 1) {
    winner_css = 'winner-ussr';
  }
  var html = "\n\n    <div class=\"war-overlay ".concat(card, "-war ").concat(winner_css, "\">\n        <div class=\"card card-hud\"><img class=\"cardimg\" src=\"/twilight/img/en/TNRnTS-01.svg\"><img class=\"cardimg\" src=\"/twilight/img/EarlyWar.svg\"><img class=\"cardimg\" src=\"/twilight/img/BothPlayerCard.svg\"><img class=\"cardimg\" src=\"/twilight/img/MayNotBeHeld.svg\"></div>\n        <div class=\"scoring-box\">\n          <div class=\"scoring-result-title\">").concat(winner, "</div>   \n\t  <div class=\"scoring-text\">\n\t    Roll: ").concat(roll, "\n\t    <p></p>\n\t    Mods: -").concat(modifications, "\n\t    <p></p>\n\t    Modified Roll: ").concat(modroll, "\n\t  </div>\n\t</div>\n    </div>\n\n  ");
  return html;
};
module.exports = WarTemplate;